class VanillaHoverScaleAnimation {
  constructor(selector = ".js-hover-scale") {
    this.selector = selector;
    this.inClass = "--is-scale-in";
    this.outClass = "--is-scale-out";

    this.init();
  }

  init() {
    const elements = document.querySelectorAll(this.selector);

    if (!elements.length) return;

    elements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        element.classList.remove(this.outClass);
        element.classList.remove(this.inClass);

        // 同じアニメーションを再実行させる
        void element.offsetWidth;

        element.classList.add(this.inClass);
      });

      element.addEventListener("mouseleave", () => {
        element.classList.remove(this.inClass);
        element.classList.remove(this.outClass);

        void element.offsetWidth;

        element.classList.add(this.outClass);
      });

      element.addEventListener("animationend", () => {
        if (element.classList.contains(this.outClass)) {
          element.classList.remove(this.outClass);
        }
      });
    });
  }
}

export default VanillaHoverScaleAnimation;
